export enum Breakpoints {
    MOBILE = 0,
    MOBILE_LARGE = 576,
    TABLET = 768,
    DESKTOP = 992,
    DESKTOP_LARGE = 1200,
    DESKTOP_xLARGE = 1440,
}
